import { render, staticRenderFns } from "./DescargaDatos.vue?vue&type=template&id=9568a53c&scoped=true&lang=es"
import script from "./DescargaDatos.vue?vue&type=script&lang=js"
export * from "./DescargaDatos.vue?vue&type=script&lang=js"
import style0 from "./DescargaDatos.vue?vue&type=style&index=0&id=9568a53c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9568a53c",
  null
  
)

export default component.exports